module.exports = __webpack_public_path__ + "static/media/distraction-car.2af0527a.png";